import { CircleCheckBig, Hourglass, TriangleAlert } from 'lucide-react';

const icons = {
  confirmed: CircleCheckBig,
  pending: Hourglass,
  needAction: TriangleAlert
};

export default icons;
